// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteria.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import PropTypes from 'prop-types';

import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Button from 'share/components/controls/Izenda.Button';
import Input from 'share/components/controls/Izenda.Input';
import DropDown from 'share/components/controls/Izenda.DropDown';
import DateTimePicker from 'share/components/controls/DateTime/Izenda.DateTimePicker';
import EventUtils from 'EventUtils';
import ReportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';

@connect()
class TextInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    criteria: PropTypes.string.isRequired,
    isFocused: PropTypes.bool,
    isEnterKeySensitive: PropTypes.bool
  };

  onSearch() {
    const { reportPartSelectionStore, loader, showResult } = this.props;

    loader.startLoading();
    return reportPartSelectionStore
      .onSearch(this.props.excludeIds)
      .then(() => {
        showResult && showResult(true);
      })
      .finally(loader.endLoading.bind(loader));
  }

  onKeyPressHandler = (event: KeyboardEvent) => {
    const { isEnterKeySensitive } = this.props;
    if (!isEnterKeySensitive)
      return;
    switch (event.key) {
      case 'Enter':
        this.onSearch();
        break;
    }
  }

  render() {
    const { label, reportPartSelection, criteria, isFocused } = this.props;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {label}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <Input
            value={reportPartSelection.getCriteria(criteria)}
            onKeyPress={this.onKeyPressHandler.bind(this)}
            onChange={EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, criteria), EventUtils.INPUT)}
            shouldFocus={isFocused}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}


@connect()
class DateInput extends Component {
  render() {
    const { label, reportPartSelection, criteria } = this.props;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols={2} className="control-label">
          {label}
        </GridLayout.Col>
        <GridLayout.Col cols={10}>
          <DateTimePicker
            time={false}
            value={reportPartSelection.getCriteria(criteria)}
            onChange={reportPartSelection.setCriteria.bind(reportPartSelection, criteria)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

@connect()
class SearchDate extends Component {
  render() {
    const { localization, label, criteria } = this.props;

    return (
      <GridLayout.Row className="form-horizontal">
        <GridLayout.Col cols={3} className="u_controlHeight control-label">
          {label}
        </GridLayout.Col>
        <GridLayout.Col cols={9}>
          <GridLayout.Row>
            <GridLayout.Col cols={6}>
              <DateInput {...this.props} criteria={criteria + 'From'} label={localization.getText('COMMON_LABEL_FROM')} />
            </GridLayout.Col>
            <GridLayout.Col cols={6}>
              <DateInput {...this.props} criteria={criteria + 'To'} label={localization.getText('COMMON_LABEL_TO')} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

@connect()
class SaveInto extends Component {
  render() {
    const { reportPartSelection, reportPartSelectionStore, localization } = this.props;
    const GLOBAL_CATEGORY_TYPES = [{
      value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.LOCAL,
      label: reportPartSelectionStore.localReportName
    }, {
      value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.GLOBAL,
      label: reportPartSelectionStore.globalReportName
    }];

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {localization.getText('COMMON_LABEL_SAVE_INTO')}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <DropDown options={GLOBAL_CATEGORY_TYPES}
            labelField={'label'}
            valueField={'value'}
            blankOption
            blankOptionText={localization.getText('COMMON_LABEL_ALL')}
            value={reportPartSelection.displayCriteria.isGlobal}
            onChange={EventUtils.notifyChange(reportPartSelectionStore.selectSaveInto.bind(reportPartSelectionStore), EventUtils.DROPDOWN)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

@connect()
class Category extends Component {
  render() {
    const { reportPartSelection, reportPartSelectionStore, localization } = this.props;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={5} className="u_controlHeight control-label">
          {localization.getText('DASHBOARD_LABEL_CATEGORY')}
        </GridLayout.Col>
        <GridLayout.Col cols={7}>
          <DropDown options={reportPartSelection.categoryCollection}
            labelField={'name'}
            valueField={'id'}
            blankOption
            blankOptionText={localization.getText('COMMON_LABEL_ALL')}
            value={reportPartSelection.displayCriteria.selectedCategory}
            onChange={EventUtils.notifyChange(reportPartSelectionStore.selectCategory.bind(reportPartSelectionStore), EventUtils.DROPDOWN)}
            disabled={reportPartSelectionStore.isCategoryDisabled}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

@connect()
class SubCategory extends Component {
  render() {
    const { reportPartSelection, reportPartSelectionStore, localization } = this.props;

    return (
      <GridLayout.Row className="form-horizontal" >
        <GridLayout.Col cols={3} className="u_controlHeight control-label">
          {localization.getText('DASHBOARD_LABEL_SUB_CATEGORY')}

        </GridLayout.Col>
        <GridLayout.Col cols={9}>
          <GridLayout.Row>
            <GridLayout.Col cols={6}>
              <DropDown options={reportPartSelection.subCategoryCollection}
                labelField={'name'}
                valueField={'id'}
                blankOption={false}
                blankOptionText={localization.getText('COMMON_LABEL_ALL')}
                value={reportPartSelection.displayCriteria.selectedSubCategory}
                onChange={EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, 'selectedSubCategory'), EventUtils.DROPDOWN)}
                disabled={reportPartSelectionStore.isSubCategoryDisabled}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

@connect()
class ButtonGroup extends Component {

  onSearch() {
    const { reportPartSelectionStore, loader, showResult } = this.props;

    loader.startLoading();
    return reportPartSelectionStore
      .onSearch(this.props.excludeIds)
      .then(() => {
        showResult && showResult(true);
      })
      .finally(loader.endLoading.bind(loader));
  }

  onReset() {
    const { reportPartSelectionStore, loader } = this.props;

    loader.startLoading();
    return reportPartSelectionStore
      .reset()
      .finally(loader.endLoading.bind(loader));
  }

  render() {
    const { localization } = this.props;

    return (
      <div className="izenda-ReportPartSelectionPopup-ActionBar u_fullWidth u_inlineBlock">
        <div className="u_paddingAll izenda-ActionBarRight">
          <Button onClick={this.onSearch.bind(this)} label={localization.getText('COMMON_LABEL_SEARCH')} />
          <Button onClick={this.onReset.bind(this)} label={localization.getText('COMMON_LABEL_RESET')} className='btn-report-default'/>
        </div>
      </div>
    );
  }
}

@connect()
export default class SearchCriteria extends Component {
  render() {
    const { localization } = this.props;

    return (
      <div>
        <GridLayout className="u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col>
              <strong>{localization.getText('SEARCH_RESULT_LABEL_SEARCH_CRITERIA')}</strong>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <SaveInto {...this.props} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <Category {...this.props} />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SubCategory {...this.props} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...this.props}
                label={localization.getText('REPORTDESIGNER_LABEL_REPORT_NAME')}
                criteria="reportName"
                isEnterKeySensitive={true}
                isFocused={true}/>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...this.props}
                label={localization.getText('COMMON_CRITERIA_CREATED_BY')}
                criteria="createdBy" />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SearchDate {...this.props} label={localization.getText('COMMON_CRITERIA_CREATED_DATE')} criteria="createdDate" />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={4}>
              <TextInput
                {...this.props}
                label={localization.getText('COMMON_CRITERIA_EDITED_BY')}
                criteria="lastEditedBy" />
            </GridLayout.Col>
            <GridLayout.Col cols={8}>
              <SearchDate {...this.props} label={localization.getText('COMMON_CRITERIA_EDITED_DATE')} criteria="lastEditedDate" />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col>
              <ButtonGroup {...this.props} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.SearchCriteria.js